import { useState } from "react";
import { Link } from "react-router-dom";
import { getLegal } from "@/lib/legal";
import ReportAbuseModal from "@/components/ReportAbuseModal";

const CONTACT_EMAIL = "support@ibeflix.com";

// Legal footer shown on every non-immersive page.
export default function LegalFooter({ language = "English" }) {
  const t = getLegal(language);
  const [reportOpen, setReportOpen] = useState(false);
  const linkCls = "text-[#A0A0AB] hover:text-[#F1F1F5] transition-colors";

  return (
    <footer data-testid="legal-footer" className="w-full border-t border-white/5 mt-12 py-6 px-4">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
        <span className="text-[#71717A]">© {new Date().getFullYear()} Ibeflix</span>
        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          <Link data-testid="footer-terms" to="/terms-of-service" className={linkCls}>{t.terms}</Link>
          <Link data-testid="footer-privacy" to="/privacy-policy" className={linkCls}>{t.privacy}</Link>
          <a data-testid="footer-contact" href={`mailto:${CONTACT_EMAIL}`} className={linkCls}>{t.contact}</a>
          <button data-testid="footer-report" onClick={() => setReportOpen(true)} className="text-[#00D9FF] hover:text-[#33E4FF] font-semibold transition-colors">
            {t.report}
          </button>
        </nav>
      </div>
      <ReportAbuseModal open={reportOpen} language={language} onClose={() => setReportOpen(false)} />
    </footer>
  );
}
